import { array, object, number } from 'yup'

import { MEMBERS_FIELD } from './model'

export const getSchema = () =>
  object().shape({
    [MEMBERS_FIELD]: array().of(number()),
  })
